module.exports = __webpack_public_path__ + "static/media/LOOM.6d703ca2.svg";